var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16317 2.36816C0.772635 2.36816 -0.0211122 3.95566 0.813211 5.06809C1.1693 5.54288 1.3618 6.12036 1.3618 6.71385V11.1182C1.3618 12.9185 2.82126 14.378 4.6216 14.378H7.3667C9.16704 14.378 10.6265 12.9185 10.6265 11.1182V6.71385C10.6265 6.12036 10.819 5.54288 11.1751 5.06809C12.0094 3.95566 11.2157 2.36816 9.82512 2.36816H2.16317ZM7.36949 5.79913C7.65375 5.79913 7.88419 6.02958 7.88419 6.31384V10.4315C7.88419 10.7158 7.65375 10.9462 7.36949 10.9462C7.08522 10.9462 6.85478 10.7158 6.85478 10.4315L6.85478 6.31384C6.85478 6.02958 7.08522 5.79913 7.36949 5.79913ZM5.13909 6.31384C5.13909 6.02958 4.90865 5.79913 4.62439 5.79913C4.34012 5.79913 4.10968 6.02958 4.10968 6.31384L4.10968 10.4315C4.10968 10.7158 4.34012 10.9462 4.62439 10.9462C4.90865 10.9462 5.13909 10.7158 5.13909 10.4315V6.31384Z",
    fill: "#6FBE45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7441 2.88207L8.51368 2.19079C8.24145 1.3741 7.47717 0.823242 6.61631 0.823242H5.3817C4.52084 0.823242 3.75656 1.3741 3.48433 2.19079L3.25391 2.88207",
    stroke: "#6FBE45",
    strokeWidth: 1.02941,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.167f400e21d463bdbdb7c66f241cb6f1.svg";
export { ForwardRef as ReactComponent };